import React, { Component, Fragment, useEffect, useState, useCallback } from 'react'
import { Route, Switch, withRouter, Redirect, Router } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Buttons from '../Ui/buttons/Buttons';
import DeleteIcon from '../../assets/images/DeleteBtn'
import * as actions from '../../store/actions/index'
import FormsInput from '../Ui/FormsInput';


import { useDispatch, useSelector } from 'react-redux'


const ShoppingCart = (props) => {

    const [authRedirect, setRedirect] = useState(false)
    const products = useSelector(state => state.product.products)
    const subTotal = useSelector(state => state.product.subTotal)
    const totalQty = useSelector(state => state.product.totalQty)
    const isAuthenticated = useSelector(state => state.auth.token)
    const loading = useSelector(state => state.product.loading)
    const totalPrice = useSelector(state => state.product.totalPrice)
    const [txtQty, setTxtQty] = useState([])
    const dispatch = useDispatch()
    const onRemoveProduct = (id) => dispatch(actions.removeFromCart(id))
    const onFetchCart = () => dispatch(actions.getAllCartService())

    useEffect(() => {
        onFetchCart()
    }, [])
    
    useEffect(() => {
        if (products) {
            const prdQty = [...txtQty];
            products.map((data, idx) => {
                const item = {
                    update_quantity: {
                        elementType: 'buttongroup',
                        variant: 'outlined',
                        label: '',
                        name: 'update_quantity',
                        elementConfig: {
                            required: true,
                        },
                        value: 0,
                        classname: 'col-md-2 mt-4',
                        validation: {
                            type: 'text',
                            required: true,
                            minLength: 1,
                            maxLength: 100
                        },
                    },
    
                }
                prdQty.push(item)
                prdQty[idx].update_quantity.value = parseInt(data.qty)
            })
            setTxtQty(prdQty)
        }
    }, [products])


    const handleCheckout = () => {
        props.history.push(`/checkout/`)
    }

    const handleLoginUrl = () => {
        setRedirect(true)
    }

    const handleIncrement = idx => {
        const prdQty = [...txtQty];
        let valueTxt = parseInt(prdQty[idx].update_quantity.value)
        prdQty[idx].update_quantity.value = valueTxt + 1
        setTxtQty(prdQty)
    }

    const handleDecrement = idx => {
        const prdQty = [...txtQty];
        let valueTxt = parseInt(prdQty[idx].update_quantity.value)
        prdQty[idx].update_quantity.value = valueTxt - 1
        setTxtQty(prdQty)
    }

    let productsCart = null

    if(products){
        if (products.length > 0 && txtQty.length > 0) {
            productsCart = products.map((data, idx) => (
                <Row key={idx} className="mb-3 border-bottom pb-3">
                    <Col md={3}>
                        <img src={data.product_sub_images_url} className="sub-card " />
                    </Col>
                    <Col md={5}>
                        <h4>{data.product_name}</h4>
                        <span className="small-header">from {data.retailer_company_name}</span>
                        <p className="sub-info">{data.product_color}</p>
                        <p className="mt-3">Qty: <span className="sub-info">
                            <FormsInput
                                elementConfig={txtQty[idx].update_quantity.elementConfig}
                                label={txtQty[idx].update_quantity.label}
                                name={txtQty[idx].update_quantity.name}
                                value={txtQty[idx].update_quantity.value}
                                classname={txtQty[idx].update_quantity.classname}
                                variant={txtQty[idx].update_quantity.variant}
                                placeholder={txtQty[idx].update_quantity.placeholder}
                                elementType={txtQty[idx].update_quantity.elementType}
                                changed={() => handleIncrement(idx)}
                                decrement={() => handleDecrement(idx)}
                            /></span></p>
                    </Col>
                    <Col md={4}>
                        <p>Per Item:  <span className="sub-info">${data.price_per_item}</span></p>
                        <p>Shipping fee:  <span className="sub-info">${data.shipping_fee}</span></p>
                        <p>Sub Total:  <span className="sub-info">${data.shipping_fee}</span></p>
                        <p>Total:  <span className="sub-info">${data.grand_total_price}</span></p>
    
                    </Col>
                    <div className="pull-right cart-icon">
                        <button
                            onClick={() => onRemoveProduct(data.id)}
                            className="btn btn-primary-outline p-0 cart-remove"
                        ><DeleteIcon width={15} height={15} /></button>
                    </div>
                </Row>
    
            ))
        }
    }
    

    let redirect = <Redirect to={{ pathname: '/login/', state: { from: "/cart" } }} />

    return (

        <Container>
            {authRedirect && redirect}
            <Row className="mt-4 pb-4">
                <Col md={8}>
                    <h2>Your Cart</h2>
                    <hr />
                    {productsCart}
                </Col>
                <Col md={4} className="gray-bg p-4">
                    <h3>Summary</h3>
                    <Row>
                        <Col md={4}>
                            Item(s)
                       </Col>
                        <Col md={4}>
                            <span className="sub-info">{totalQty}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            Subtotal
                       </Col>
                        <Col md={4}>
                            ${subTotal}
                        </Col>
                    </Row>
                    <Row className="border-top border-bottom mt-4 pt-3 pb-3 mt-3">
                        <Col md={4}>
                            <p className="sub-info">Total</p>
                        </Col>
                        <Col md={8}>
                            <p className="sub-info">${totalPrice}</p>
                        </Col>
                    </Row>

                    <Row className='mt-2'>
                        <Col sm={12}>
                            {
                                isAuthenticated ?
                                    <Buttons
                                        buttonType="primary"
                                        buttonAction={() => handleCheckout()}
                                        buttontext="Checkout"
                                        classInput="col-md-12 mt-4"
                                        disabled={!isAuthenticated}
                                    />
                                    :
                                    <Buttons
                                        buttonType="primary"
                                        buttonAction={() => handleLoginUrl()}
                                        buttontext="Login"
                                        classInput="col-md-12 mt-4"
                                    />
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>


        </Container>
    );


}
export default ShoppingCart;